import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { Client, InvoiceViewModel } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';

@Component({})
export default class RecentOrdersComponent extends ABaseComponent {

    orders: InvoiceViewModel[] = [];
    filteredOrders: InvoiceViewModel[] = [];
    search: string = '';

    @Prop({default: 'LANG1'})
    languageId: string;

    @Prop({ default: '' })
    porterNo: string;

    @Watch('search')
    async onSearchChanged() {
        this.filteredOrders = this.orders.filter(order => 
            order.invoice.orderId.toUpperCase().includes(this.search.toUpperCase()) ||
            order.invoice.extraInfo['SellToCustomerName'].toUpperCase().includes(this.search.toUpperCase()) ||
            order.invoice.extraInfo['SalesMainDepartment'].toUpperCase().includes(this.search.toUpperCase()) ||
            order.invoice.extraInfo['SellToCustomerNo'].toUpperCase().includes(this.search.toUpperCase())
        )
    }

    get locations() {
        let result: { [customerName: string]: InvoiceViewModel[] } = {};
        if (this.filteredOrders) {
            this.filteredOrders.forEach(item => {
                let key = item.invoice.extraInfo['SellToCustomerName'] || '';

                let invoices = result[key];
                if (!invoices) {
                    result[key] = invoices = [];
                }
                invoices.push(item);
            });
        }
        return result;
    }

    async created() {
        await this.load();
    }

    async load() {
        this.setLoading();
        try {
            const client = ApiProvider.getApiClient();
            let recentOrders = await client.getRecentOrders(this.languageId,this.porterNo);
            this.orders = recentOrders.orders;
            this.filteredOrders = recentOrders.orders;
            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }

}

Vue.component('recent-orders', RecentOrdersComponent);
